module.exports = __webpack_public_path__ + "img/living_thumbnail_mobile.ab86843e.jpg";